import { categories } from '@/mocks/homeData';

const CTASection = () => (
  <section className="relative bg-background-100 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
      <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">
        Comece Agora
      </h2>
      <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md mx-auto">
        Mais de 20.000 produtos selecionados no maior <strong>Hoobuy Spreadsheet</strong> em português.
      </p>
      <div className="mt-8">
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 text-lg font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Explorar Spreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="mt-16 flex flex-wrap justify-center gap-2">
        {categories.map((cat) => (
          <a
            key={cat.nameEn}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-4 py-2 bg-background-50 border border-background-200 rounded-full text-xs font-medium text-foreground-700 hover:border-background-400 hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {cat.name}
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default CTASection;